export default __webpack_public_path__ + "static/Horizon-2688fa10dac6b1bb954019f6d6d0b2fc.png";